// extracted by mini-css-extract-plugin
export default {"container":"SendMessage_container__cTEli","input":"SendMessage_input__iw29J","button":"SendMessage_button__0zkeV"};